/* @flow */

import { type Retorno } from './types';
import getTitulo from './get-titulo';
import swal from '../../swal';
import { type EtapasId } from '../types';


const swalAlterarEtapa = (etapasId: EtapasId, options?: *): Promise<Retorno> => (
    swal.fire({
        title: getTitulo(etapasId),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Alterar',
        ...options,
    })
        .then((result) => {
            if (result.dismiss) {
                return Promise.reject();
            }
            return result;
        })
);

export default swalAlterarEtapa;
